import {useSelector} from 'react-redux'
import {getIsOfferSoldOut} from 'modules/accommodation/selectors'
import {SearchOffer} from 'modules/sapiSearch/slice'

import {Offer} from '@vio/core/src/offer/types/offer'
import {SplitBooking} from '@vio/core/src/room/types/room'

export const useGetIsOfferSoldOut = ({
  offer,
  splitBooking
}: {
  offer?: Offer | SearchOffer
  splitBooking?: SplitBooking
}) => {
  const id = offer?.id || splitBooking?.bundleId

  const isSoldOut = useSelector(state => getIsOfferSoldOut(state, id))

  return isSoldOut
}
